import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { Button, Input, ModalBody, ModalFooter } from "@/modules/common/components";
import useSendRecoveryCode from "../../hooks/useSendRecoveryCode";
import { ForgotPasswordEmailFormData, forgotPasswordEmailSchema } from "../../schemas";

interface EmailStepProps {
  onClose: () => void;
  onSent: (email: string) => void;
}

const EmailStep = ({ onClose, onSent }: EmailStepProps) => {
  const sendRecoveryCode = useSendRecoveryCode();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordEmailFormData>({ resolver: zodResolver(forgotPasswordEmailSchema) });

  const onSubmit = async (values: ForgotPasswordEmailFormData) => {
    await sendRecoveryCode.mutateAsync(values);
    onSent(values.email);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ModalBody className="gap-1">
        <Input label="E-mail" maskType="email" markAsRequired data-test="forgot-password-email" {...register("email")} />
        {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email.message}</p>}
      </ModalBody>
      <ModalFooter>
        <Button type="button" label="Cancelar" variant="outlined" onClick={onClose} className="w-full" />
        <Button
          type="submit"
          className="w-full"
          label="Enviar"
          disabled={sendRecoveryCode.isPending}
          loading={sendRecoveryCode.isPending}
          data-test="forgot-password-send-code"
        />
      </ModalFooter>
    </form>
  );
};

export default EmailStep;
